// extracted by mini-css-extract-plugin
export default {"resourceVersions":"resourceVersions___I4pJN","resourceVersion":"resourceVersion___eoh4D","versionText":"versionText___y2j5m"};